export default function formatPrice(value: number) {
    let formated = value.toLocaleString('pt-BR', {minimumFractionDigits: 2})
    return formated
}